import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appMuTableCellEditor]',
})
export class MuTableCellEditorDirective {
  @Input('appMuTableCellEditor') name: string;

  constructor(public template: TemplateRef<any>) {
    /** */
  }
}
